import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limit'
})
export class LimitPipe implements PipeTransform {
  // adds a limit to the number of items displayed in a list and displays the first n items
  //ex: *ngFor="let data of dataList | limit: 5;"
  transform(value: any[], limit: number): any[] {
    if (!Array.isArray(value)) {
      return value;
    }
    return value.slice(0, limit);
  }
}